import PropTypes from 'prop-types';
import React     from 'react';

import {toClassStr} from '_utils/UiHelper';


const NavLink = (props) => {
  const classes = toClassStr(['nav-link', props.className, props.addClasses]);

  return (
    <div>
      <span className={classes} onClick={props.onClick}>
        {props.children}
      </span>
    </div>
  );
}

NavLink.propTypes = {
  className: PropTypes.string,
  onClick:   PropTypes.func.isRequired,
};

export default NavLink;
